var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSnb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    width: 200,
    height: 200,
    style: {
      shapeRendering: "auto",
      display: "block",
      background: "transparent"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    strokeLinecap: "round",
    fill: "none",
    strokeDasharray: "50.26548245743669 50.26548245743669",
    stroke: "#034638",
    strokeWidth: 8,
    r: 32,
    cy: 50,
    cx: 50
  }, /*#__PURE__*/React.createElement("animateTransform", {
    values: "0 50 50;360 50 50",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    dur: "1s",
    type: "rotate",
    attributeName: "transform"
  })), /*#__PURE__*/React.createElement("circle", {
    strokeLinecap: "round",
    fill: "none",
    strokeDashoffset: 36.12831551628262,
    strokeDasharray: "36.12831551628262 36.12831551628262",
    stroke: "#84bd00",
    strokeWidth: 8,
    r: 23,
    cy: 50,
    cx: 50
  }, /*#__PURE__*/React.createElement("animateTransform", {
    values: "0 50 50;-360 50 50",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    dur: "1s",
    type: "rotate",
    attributeName: "transform"
  })), /*#__PURE__*/React.createElement("g", null))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnb);
export default __webpack_public_path__ + "static/media/snb.e29334b83a799beda5facd7cd22d6180.svg";
export { ForwardRef as ReactComponent };